"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Day = _interopRequireDefault(require("./Day"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Period {
  constructor() {
    _defineProperty(this, "period", 1);

    _defineProperty(this, "days", []);
  }

  static fromObject(obj) {
    let p = new Period();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'period':
          p[key] = value;
          break;

        case 'days':
          p[key] = value.map(day => _Day.default.fromObject(day));
          break;
      }
    });
    return p;
  }

}

exports.default = Period;